import "./CreateNewDatasetDialog.less"
import { CloseBtn } from "../CloseBtn/CloseBtn";
import { Input } from "antd";
import React, { useState } from "react";
import CustomButton from "../CustomButton/CustomButton";

export class CreateNewDatasetDialogStatus{
    isVisible: boolean = false;
    dialogTitle: string = "";
    title: string = "";
    description: string = "";
    onConfirm: (title: string, description: string) => void;

    constructor(isVisible: boolean, dialogTitle: string, title: string, description: string, onConfirm: (title: string, description: string) => void){
        this.isVisible = isVisible;
        this.dialogTitle = dialogTitle;
        this.title = title;
        this.description = description;
        this.onConfirm = onConfirm;
    }
};

type CreateNewDatasetDialogProps = {
    onClose: () => void;
    status: CreateNewDatasetDialogStatus;
};

const MAX_TITLE_LEN = 12;
const MAX_DESCRIPTION_LEN = 30;

export const CreateNewDatasetDialog = (props: CreateNewDatasetDialogProps): React.ReactElement => {
    const [title, setTitle] = useState(props.status.title);
    const [description, setDescription] = useState(props.status.description);

    const onTitleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setTitle(e.target.value);
    };

    const onDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
        setDescription(e.target.value);
    };

    return <div className="fullscreen-dialog-bg-color fullscreen-mask">
        <div className="create-new-dataset-dialog">
            <CloseBtn onClick={props.onClose}></CloseBtn>
            <div className="create-new-dataset-dialog-title">{props.status.dialogTitle}</div>
            <div className="create-new-dataset-dialog-content">
                <div className="create-new-dataset-hint">数据集名称</div>
                <div className="create-new-dataset-title-frame">
                    <Input className="create-new-dataset-input" variant="borderless" value={title} onChange={onTitleChange} maxLength={MAX_TITLE_LEN} placeholder="请输入数据集名称"></Input>
                    <span>{title.length}/{MAX_TITLE_LEN}</span>
                </div>
                <div className="create-new-dataset-hint">数据集描述</div>
                <div className="create-new-dataset-description-frame">
                    <Input.TextArea className="create-new-dataset-input" style={{resize:"none"}} variant="borderless" value={description} onChange={onDescriptionChange} maxLength={MAX_DESCRIPTION_LEN} placeholder="请输入数据集的详细信息"></Input.TextArea>
                    <span>{description.length}/{MAX_DESCRIPTION_LEN}</span>
                </div>
                <CustomButton className="create-new-dataset-confirm-btn" onClick={() => props.status.onConfirm(title, description)}>确定</CustomButton>
            </div>
        </div>
    </div>;
};